const $ = jQuery;

class PartnerSlider {
    constructor() {
        this.slider = $('.c-slider.cc-partner_slider');
        this.prevButton = $('.e-slider_btn.cc-prev.cc-partner_slider');
        this.nextButton = $('.e-slider_btn.cc-next.cc-partner_slider');
        this.isMobile = document.documentElement.clientWidth < 768;
        this.slickInitialized = false;
        this.resizeTimer = null;
        
        this.init();
        this.bindEvents();
    }

    init() {
        if (this.slider.length > 0) {
            this.setSliderItemHeight();
            this.initSlider();
        } else {
            console.warn('Slider element not found');
        }
    }

    bindEvents() {
        $(window).on('resize', () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                const wasMobile = this.isMobile;
                this.isMobile = document.documentElement.clientWidth < 768;
                
                // Only reinitialize if we crossed the mobile/desktop threshold
                if (wasMobile !== this.isMobile && this.slickInitialized) {
                    this.slider.slick('unslick');
                    this.slickInitialized = false;
                    this.setSliderItemHeight();
                    this.initSlider();
                }
            }, 250);
        });
    }

    setSliderItemHeight() {
        if (this.isMobile) {
            // Get average height of images and set as variable
            const images = this.slider.find('.c-slider_item_img');
            let totalHeight = 0;
            images.each(function() {
                totalHeight += $(this).height();
            });
            
            if (images.length > 0) {
                const avgHeight = totalHeight / images.length;
                document.documentElement.style.setProperty('--slider-item-height', avgHeight + 'px');
            }
        }
    }

    initSlider() {
        if (this.isMobile) {
            // Mobile configuration (two rows)
            this.slider.slick({
                // slidesToScroll: 1,
                rows: 1,
                arrows: true,
                dots: false,
                infinite: true,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: 'linear',
                prevArrow: this.prevButton,
                nextArrow: this.nextButton,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            // slidesToShow: 8,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            // slidesToShow: 6,
                        }
                    }
                ]
            });
        } else {
            // Desktop configuration
            this.slider.slick({
                // slidesToScroll: 1,
                rows: 1,
                arrows: true,
                dots: false,
                infinite: true,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: 'linear',
                prevArrow: this.prevButton,
                nextArrow: this.nextButton,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            // slidesToShow: 8,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            // slidesToShow: 6,
                        }
                    }
                ]
            });
        }
        
        this.slickInitialized = true;
    }
}

export default PartnerSlider;